import { render, staticRenderFns } from "./SelectCategoryOnboarding.vue?vue&type=template&id=969c2d0a&scoped=true&"
import script from "./SelectCategoryOnboarding.vue?vue&type=script&lang=js&"
export * from "./SelectCategoryOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./SelectCategoryOnboarding.vue?vue&type=style&index=0&id=969c2d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969c2d0a",
  null
  
)

export default component.exports